import React, {createContext, useContext, useEffect, useState} from 'react';
import {SettingsApi} from '../api';

interface ICookieContextProvider {
    showFooter: boolean | undefined;

    cookieUrl: string | undefined;

    googleAnalyticsId: string | undefined;

    googleAnalyticsDomain: string | undefined;

    gtmContainerId: string | undefined;
}

export const CookieContext = createContext<ICookieContextProvider>({
    showFooter: undefined,

    cookieUrl: undefined,

    googleAnalyticsId: undefined,

    googleAnalyticsDomain: undefined,

    gtmContainerId: undefined,
});

const CookieProvider = (props: {children: React.ReactNode}) => {
    const [showFooter, setShowFooter] = useState<boolean | undefined>(undefined);
    const [cookieUrl, setCookieUrl] = useState<string | undefined>(undefined);
    const [googleAnalyticsId, setGoogleAnalyticsId] = useState<string | undefined>(undefined);
    const [googleAnalyticsDomain, setGoogleAnalyticsDomain] = useState<string | undefined>(undefined);
    const [gtmContainerId, setGtmContainerId] = useState<string | undefined>(undefined);

    useEffect(() => {
        SettingsApi.getCookiesInfo().then(res => {
            const cookiesSetting = res.data;
            setShowFooter(cookiesSetting.showFooter);
            setGoogleAnalyticsId(cookiesSetting.googleAnalyticsId);
            setGoogleAnalyticsDomain(cookiesSetting.googleAnalyticsDomain);
            setCookieUrl(cookiesSetting.cookieUrl);
            setGtmContainerId(cookiesSetting.gtmContainerId);
        });
    }, []);

    return (
        <CookieContext.Provider
            value={{
                showFooter,
                cookieUrl,
                googleAnalyticsId,
                googleAnalyticsDomain,
                gtmContainerId,
            }}
        >
            {props.children}
        </CookieContext.Provider>
    );
};

export default CookieProvider;
